import React from 'react';
import { PrimaryButton, TertiaryButton, SecondaryButton } from '@fremtind/jkl-button-react';
import classNames from 'classnames';

var Card = function Card(_ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      media = _ref.media,
      action = _ref.action,
      dark = _ref.dark,
      clickable = _ref.clickable;
  var componentClassName = classNames("jkl-card", className, {
    "jkl-card--dark": dark,
    "jkl-card--clickable": clickable
  });
  var Button = PrimaryButton;

  if (action) {
    switch (action.type) {
      case "secondary":
        Button = SecondaryButton;
        break;

      case "tertiary":
        Button = TertiaryButton;
        break;
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "jkl-card",
    className: componentClassName
  }, media && /*#__PURE__*/React.createElement("img", {
    className: "jkl-card__media",
    src: media.src,
    alt: media.alt
  }), title && /*#__PURE__*/React.createElement("div", {
    "data-testid": "jkl-card__title",
    className: "jkl-card__title jkl-h3"
  }, clickable ? /*#__PURE__*/React.createElement("a", {
    className: "jkl-card__link",
    href: clickable.href,
    onClick: clickable.onClick
  }, title) : title), /*#__PURE__*/React.createElement("div", {
    className: "jkl-card__children"
  }, children), action && /*#__PURE__*/React.createElement("div", {
    className: "jkl-card__action"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: action.onClick
  }, action.name)));
};

export { Card };
